export default "__VITE_ASSET__5e87e56f__"